export default {
  root: {
    height: 26,
    width: 26,
    fontSize: 26,
  },
}
